export default "__VITE_ASSET__kziTwS38__"